import { render, staticRenderFns } from "./BookingSiteTemplateEditor.vue?vue&type=template&id=0d53f87c"
import script from "./BookingSiteTemplateEditor.vue?vue&type=script&lang=js"
export * from "./BookingSiteTemplateEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports